import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Grid, GridProps } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles(theme => createStyles({
	root: {
		marginBottom: theme.spacing(2),
		alignItems: 'center',
		justifyContent: 'space-evenly',
		flexDirection: 'column',
	},
}));

const AlertContainer: React.FC<GridProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Grid
			container
			className={classNames(classes.root, className)}
			{...props}
		>
			{children}
		</Grid>
	);
};

export default AlertContainer;
